module.exports = __webpack_public_path__ + "static/media/notepad.9fe71690.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/writing/notepad.svg
// module id = 103
// module chunks = 0